import { withoutForbiddenXmlCharacters } from '@eformulieren/model'
import { Fragment, type Node as ProseMirrorNode, Slice } from '@tiptap/pm/model'

/**
 * Een geplakte of gesleepte slice zonder de tekens die XML 1.0 niet toelaat (koppelvlak hoofdstuk 3,
 * `xmlCharacters.ts` in het model).
 *
 * Op de slice en niet op de tekst van het klembord: geplakte HTML wordt pas hier tekst, en een
 * tekenverwijzing als `&#1;` is dan het teken zelf. Ook de attributen gaan mee, want een formule of
 * een link draagt haar tekst daar. Dit gebeurt vóór de slice in de editor komt, dus er wordt niets in
 * het gedeelde document herschreven (valkuil 2 en 3 blijven buiten beeld).
 */
export function withoutForbiddenInSlice(slice: Slice): { readonly slice: Slice; readonly removed: boolean } {
  let removed = false
  const clean = (text: string): string => {
    const out = withoutForbiddenXmlCharacters(text)
    if (out !== text) removed = true
    return out
  }
  const attributes = (attrs: ProseMirrorNode['attrs']): ProseMirrorNode['attrs'] => {
    const out: Record<string, unknown> = {}
    for (const [name, value] of Object.entries(attrs)) out[name] = typeof value === 'string' ? clean(value) : value
    return out
  }
  const map = (fragment: Fragment): Fragment => {
    const nodes: ProseMirrorNode[] = []
    fragment.forEach((node) => {
      if (node.isText) {
        const text = clean(node.text ?? '')
        if (text !== '') nodes.push(node.type.schema.text(text, node.marks))
        return
      }
      nodes.push(node.type.create(attributes(node.attrs), map(node.content), node.marks))
    })
    return Fragment.fromArray(nodes)
  }
  const content = map(slice.content)
  return { slice: removed ? new Slice(content, slice.openStart, slice.openEnd) : slice, removed }
}
